import { TagGi } from "./tag-gi";

export class AtualizaDA {
    ids: number[];
    tipoDa: number;
    valorDA: number;
    idusuario: number;
    nomeUsuario: string;
    dataHora: Date;
    filtroJson: FiltroJSON;
    idLog: number;
    tag: TagGi[];
    nomeVendedores: string;
}

export class FiltroDA {
    id: number;
    idusuario: number;
    descricao: string;
    tipoDA: number;
    valorDA: number | null;
    filtroJson: FiltroJSON;
    dataHora: Date;
}

export class FiltroJSON {
    cidade: string;
    uf: string;
    idVendedor?: number;
    tags?: number[];
    status?: number;
    vendedores?: number[];
}